export enum PageType {
    Basic = 1,
    CreateAsset = 2,
    UserDetails = 3,
    AssetDetails = 4,
    CreateAction = 5,
    ActionDetails = 6
}
